// TTS Voices Data

export const kokoroAmericanEnglishVoices = [
  {
    value: 'af_alloy',
    label: 'Alloy',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/af_alloy.mp3',
  },
  {
    value: 'af_aoede',
    label: 'Aoede',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/af_aoede.mp3',
  },
  {
    value: 'af_bella',
    label: 'Bella',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/af_bella.mp3',
  },
  {
    value: 'af_heart',
    label: 'Heart',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/af_heart.mp3',
  },
  {
    value: 'af_jessica',
    label: 'Jessica',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/af_jessica.mp3',
  },
  {
    value: 'af_kore',
    label: 'Kore',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/af_kore.mp3',
  },
  {
    value: 'af_nicole',
    label: 'Nicole',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/af_nicole.mp3',
  },
  {
    value: 'af_nova',
    label: 'Nova',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/af_nova.mp3',
  },
  {
    value: 'af_river',
    label: 'River',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/af_river.mp3',
  },
  {
    value: 'af_sarah',
    label: 'Sarah',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/af_sarah.mp3',
  },
  {
    value: 'af_sky',
    label: 'Sky',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/af_sky.mp3',
  },
  {
    value: 'am_adam',
    label: 'Adam',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/am_adam.mp3',
  },
  {
    value: 'am_echo',
    label: 'Echo',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/am_echo.mp3',
  },
  {
    value: 'am_eric',
    label: 'Eric',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/am_eric.mp3',
  },
  {
    value: 'am_fenrir',
    label: 'Fenrir',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/am_fenrir.mp3',
  },
  {
    value: 'am_liam',
    label: 'Liam',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/am_liam.mp3',
  },
  {
    value: 'am_michael',
    label: 'Michael',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/am_michael.mp3',
  },
  {
    value: 'am_onyx',
    label: 'Onyx',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/am_onyx.mp3',
  },
  {
    value: 'am_puck',
    label: 'Puck',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/am_puck.mp3',
  },
  {
    value: 'am_santa',
    label: 'Santa',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-american/am_santa.mp3',
  },
]

export const kokoroBritishEnglishVoices = [
  {
    value: 'bf_alice',
    label: 'Alice',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-british/bf_alice.mp3',
  },
  {
    value: 'bm_daniel',
    label: 'Daniel',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-british/bm_daniel.mp3',
  },
  {
    value: 'bf_emma',
    label: 'Emma',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-british/bf_emma.mp3',
  },
  {
    value: 'bm_fable',
    label: 'Fable',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-british/bm_fable.mp3',
  },
  {
    value: 'bm_george',
    label: 'George',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-british/bm_george.mp3',
  },
  {
    value: 'bf_isabella',
    label: 'Isabella',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-british/bf_isabella.mp3',
  },
  {
    value: 'bm_lewis',
    label: 'Lewis',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-british/bm_lewis.mp3',
  },
  {
    value: 'bf_lily',
    label: 'Lily',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/english-british/bf_lily.mp3',
  },
]

export const kokoroJapaneseVoices = [
  {
    value: 'jf_alpha',
    label: 'Alpha',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/japanese/jf_alpha.mp3',
  },
  {
    value: 'jf_gongitsune',
    label: 'Gongitsune',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/japanese/jf_gongitsune.mp3',
  },
  {
    value: 'jf_nezumi',
    label: 'Nezumi',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/japanese/jf_nezumi.mp3',
  },
  {
    value: 'jf_tebukuro',
    label: 'Tebukuro',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/japanese/jf_tebukuro.mp3',
  },
  {
    value: 'jm_kumo',
    label: 'Kumo',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/japanese/jm_kumo.mp3',
  },
]

export const kokoroMandarinChineseVoices = [
  {
    value: 'zf_xiaobei',
    label: 'Xiaobei',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/chinese/zf_xiaobei.mp3',
  },
  {
    value: 'zf_xiaoni',
    label: 'Xiaoni',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/chinese/zf_xiaoni.mp3',
  },
  {
    value: 'zf_xiaoxiao',
    label: 'Xiaoxiao',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/chinese/zf_xiaoxiao.mp3',
  },
  {
    value: 'zf_xiaoyi',
    label: 'Xiaoyi',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/chinese/zf_xiaoyi.mp3',
  },
  {
    value: 'zm_yunjian',
    label: 'Yunjian',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/chinese/zm_yunjian.mp3',
  },
  {
    value: 'zm_yunxia',
    label: 'Yunxia',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/chinese/zm_yunxia.mp3',
  },
  {
    value: 'zm_yunxi',
    label: 'Yunxi',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/chinese/zm_yunxi.mp3',
  },
  {
    value: 'zm_yunyang',
    label: 'Yunyang',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/chinese/zm_yunyang.mp3',
  },
]

export const kokoroSpanishVoices = [
  {
    value: 'em_alex',
    label: 'Alex',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/spanish/em_alex.mp3',
  },
  {
    value: 'ef_dora',
    label: 'Dora',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/spanish/ef_dora.mp3',
  },
  {
    value: 'em_santa',
    label: 'Santa',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/spanish/em_santa.mp3',
  },
]

export const kokoroFrenchVoices = [
  {
    value: 'ff_siwis',
    label: 'Siwis',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/french/ff_siwis.mp3',
  },
]

export const kokoroItalianVoices = [
  {
    value: 'if_sara',
    label: 'Sara',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/italian/if_sara.mp3',
  },
  {
    value: 'im_nicola',
    label: 'Nicola',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/italian/im_nicola.mp3',
  },
]

export const kokoroBrazilianPortugueseVoices = [
  {
    value: 'pf_dora',
    label: 'Dora',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/portuguese-brazil/pf_dora.mp3',
  },
  {
    value: 'pm_alex',
    label: 'Alex',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/portuguese-brazil/pm_alex.mp3',
  },
  {
    value: 'pm_santa',
    label: 'Santa',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/portuguese-brazil/pm_santa.mp3',
  },
]

export const kokoroHindiVoices = [
  {
    value: 'hf_alpha',
    label: 'Alpha',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/hindi/hf_alpha.mp3',
  },
  {
    value: 'hf_beta',
    label: 'Beta',
    gender: 'female',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/hindi/hf_beta.mp3',
  },
  {
    value: 'hm_omega',
    label: 'Omega',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/hindi/hm_omega.mp3',
  },
  {
    value: 'hm_psi',
    label: 'Psi',
    gender: 'male',
    audioUrl:
      'https://cdn.minicoursegenerator.com/assets/tts/advanced/hindi/hm_psi.mp3',
  },
]

export const languages = [
  { code: 'en-US', name: 'English (American)' },
  { code: 'en-GB', name: 'English (British)' },
  { code: 'ja', name: 'Japanese' },
  { code: 'zh', name: 'Mandarin Chinese' },
  { code: 'es', name: 'Spanish' },
  { code: 'fr', name: 'French' },
  { code: 'hi', name: 'Hindi' },
  { code: 'it', name: 'Italian' },
  { code: 'pt', name: 'Portuguese (Brazil)' },
]
